import StructuredData from 'components/StructuredData';

function WebSiteStructuredData(): JSX.Element {
  const data = {
    '@type': 'WebSite',
    name: 'Autolist',
    url: 'https://www.autolist.com',
  };

  return <StructuredData data={data} />;
}

export default WebSiteStructuredData;
